import { Component, OnInit } from '@angular/core';
import {NgForOf, NgIf} from '@angular/common';

@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.component.html',
    standalone: true,
    imports: [
        NgForOf,
        NgIf
    ],
    styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {
    selectedTab: number | null = 0;
    accordionOpen: number | null = null;
    tabs = [
        { label: 'Admission Management Module (AMM)',
            image : 'assets/image/AMM Dashboard.webp',
            content: 'The AMM streamlines admission processes, including marking, lateral entries, credit transfers, student re-registration, follow-ups, reminders, and multiple admissions. It integrates social media leads, manages multiple branches, and offers accounting and reporting panels.\n' },
        { label: 'Student Management Module (SMM)',
            image : 'assets/image/SMM Dashboard-02.png',
            content: 'The SMM provides a comprehensive and robust learning management system, including advanced chatbot integrations, streamlined admission forms, social media integration, real-time notifications, customizable reminders, interactive video sessions, live lectures, personalized support services, and detailed examination and documentation management for students.' },
        { label: 'Management Administrative Module (MAM)',
            image : 'assets/image/MAM Dashboard.webp',
            content: 'The MAM system manages knowledge partners, sessions, student lead inquiries, enrollment ID generation, accounting, reporting, Learning Management System, EMS, online/offline examinations, email notifications, question paper upload, DMS, and support services.' },
    ];

  constructor() { }

  ngOnInit(): void {
  }




    selectTab(index: number) {
        this.selectedTab = index;
    }

    toggleAccordion(index: number) {
        this.accordionOpen = this.accordionOpen === index ? null : index;
    }

}
